/**
 * Enum trạng thái form đồng bộ
 * nxhinh 02.10.2024
 */
export default {
    // Gộp
    Merge: 1,
    // Xóa
    Delete: 2,
    // Đổi tên
    Rename: 3
  };
  